
export enum DeliveryForm
{
    Unset = "Unset",
    Package = "Package",
    Personal = "Personal",
    Inpost = "Inpost",
}

export const DeliveryFormValueToLabel = {
    [DeliveryForm.Unset]: "(forma dostawy nieokreślona)",
    [DeliveryForm.Package]: "Paczka (kurier Pocztex)",
    [DeliveryForm.Personal]: "Odbiór osobisty",
    [DeliveryForm.Inpost]: "Paczkomat Inpost",
}
